import { defineComponent, getCurrentInstance } from 'vue';
import { useStore } from '@/store';
export default defineComponent({
    setup(props) {
        const store = useStore();
        const root = getCurrentInstance().proxy;
        return {
            logout() {
                store.commit('auth/CLEAR');
                root.$router.push({ path: '/login' });
            }
        };
    }
});
